import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

const footerGroups = [
  {
    title: "Shop",
    links: [
      ["Keyboards", "/shop?category=Keyboards"],
      ["Mice", "/shop?category=Mice"],
      ["Mousepads", "/shop?category=Mousepads"],
      ["Accessories", "/shop?category=Accessories"],
    ],
  },
  {
    title: "Help",
    links: [
      ["Contact", "/contact"],
      ["Shipping", "/shipping"],
      ["Returns", "/returns"],
      ["FAQs", "/faqs"],
      ["Your bag", "/cartpage"],
    ],
  },
  {
    title: "Company",
    links: [
      ["Our story", "/about"],
      ["Privacy", "/privacy"],
      ["Terms", "/terms"],
      ["Cookies", "/cookies"],
    ],
  },
];

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__top">
        <div className="site-footer__newsletter">
          <p className="eyebrow">HUSHCIDER SUPPORT</p>
          <h2>DESK GEAR,<br />CLEARLY MADE.</h2>
          <p>Questions about products, delivery, returns, or your order? Our Hong Kong support team is ready to help.</p>
          <a className="site-footer__contact" href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
        </div>

        <div className="site-footer__links">
          {footerGroups.map((group) => (
            <div key={group.title}>
              <p>{group.title}</p>
              {group.links.map(([label, path]) => (
                <Link key={label} to={path}>{label}</Link>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="site-footer__social">
        <span>SUPPORTED PAYMENT METHODS</span>
        <div className="site-footer__payments" aria-label="Supported payment methods">
          <span>VISA</span><span>MASTERCARD</span><span>AMEX</span><span>APPLE PAY</span><span>GOOGLE PAY</span>
        </div>
      </div>

      <div className="site-footer__wordmark" aria-hidden="true">
        {siteConfig.wordmark}
      </div>
      <div className="site-footer__bottom">
        <span>© {new Date().getFullYear()} {siteConfig.wordmark}</span>
        <span>{siteConfig.contact.address} · {siteConfig.contact.email}</span>
      </div>
    </footer>
  );
}

export default Footer;
